import { LocaleSelector } from "../../../LocaleSelector";

export function SidebarLocaleToggle() {
  return <LocaleSelector variant="sidebar" />;
}
